<div [formGroup]="group">
  <mat-form-field appearance="outline">
    <mat-label i18n="Timepicker 1 Title">{{ config.label }}</mat-label>
    <input
      matTimepicker
      #t1="matTimepicker"
      i18n-okLabel="Timepicker 1 Ok Label"
      okLabel="OK"
      i18n-cancelLabel="Timepicker 1 Cancel Label"
      cancelLabel="CANCELAR"
      [formControlName]="config.name"
      id="timepicker-example-1"
      mode="24h"
      placeholder="SELECIONE"
      name="time-1"
    />
    <mat-icon matSuffix (click)="t1.showDialog()">access_time</mat-icon>
  </mat-form-field>
</div>
